import React, { useContext } from 'react';
import { AppContext } from '@prisjakt/ui-app-context';

import { BodyMediumText } from '@prisjakt/ui/text/variants';

import { PopularSearches } from 'src/components/popular-searches';

import { PopularSearch } from 'src/types';
import { useEffectOnMount } from 'src/hooks/useEffectOnMount';

import {
  List,
  ListItem,
  ListTitle,
  NoResult,
  PopularSearchesTitle,
  Strikeover,
  NoSearchResultWrapperPic,
} from './styles';

type Props = {
  onRender?: () => void;
  popularSearches?: (PopularSearch | null)[];
};

export const NoSearchResults = (props: Props) => {
  const { market, t } = useContext(AppContext);
  const { popularSearches } = props;

  useEffectOnMount(() => {
    if (props.onRender) props.onRender();
  });

  return (
    <>
      <NoResult gap={1}>
        <BodyMediumText>
          <ListTitle>{t('search', 'search.no-results-title')}</ListTitle>
          <List>
            <ListItem>
              {t('search', 'search.no-results-subtitle', {
                item: (
                  <Strikeover>
                    {t('search', 'search.no-results-subtitle-1')}
                  </Strikeover>
                ),
              })}
            </ListItem>
            <ListItem>{t('search', 'search.no-results-subtitle-2')}</ListItem>
          </List>
        </BodyMediumText>

        <div>
          <NoSearchResultWrapperPic
            src={`${market.cdn}/g/rfe/illustrations/no-search-result-illustration.png`}
            alt={t('search', 'results.no-product-found')}
          />
        </div>
      </NoResult>

      {popularSearches?.length ? (
        <>
          <PopularSearchesTitle>
            {t('search', 'search.popular-searches')}
          </PopularSearchesTitle>
          <PopularSearches popularSearches={popularSearches} />
        </>
      ) : null}
    </>
  );
};
